import { __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import { CustomErrorSection } from './CustomErrorSection.esm.js';
import Figure500 from './Figures/Figure500.esm.js';

var DEFAULT_VALUES = {
    ctaText: 'Go back',
    description: 'We can interpret your genetic code. <b>But we can’t interpret that request.</b> We are sorry for the inconvenience. You can try:',
    figure: React.createElement(Figure500, null),
    headingText: 'Oops!',
    pageTitle: 'Internal server error',
    textList: [
        "Refreshing the page",
        "Contacting us at <a href=\"tel:+1-800-436-3037\">(800) 436-3037</a> (5:00 am - 5:00 pm Pacific) or emailing us\n    at <a href=\"mailto:clientservices@invitae.com\">clientservices@invitae.com</a>",
        "Accessing the <a href=\"/patients/dashboard/ \">patient portal</a>",
        "Accessing the <a href=\"/hcp/order-history\">provider portal</a>",
    ],
    title: '500. Internal server error.',
};
var InternalServerErrorPage = function (props) {
    var componentProps = __assign(__assign({}, DEFAULT_VALUES), props);
    return React.createElement(CustomErrorSection, __assign({}, componentProps));
};

export { DEFAULT_VALUES, InternalServerErrorPage };
//# sourceMappingURL=InternalServerErrorPage.esm.js.map
